module.exports = __webpack_public_path__ + "static/media/dummy_header.674ce62d.jpg";